module.exports = __webpack_public_path__ + "bf9b6110a3cce0cf1ea0719ae3325135.svg";